import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-save-icon',
  templateUrl: './lib-save-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibSaveIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
